import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Roundtripcabbookingmumbai() {



const cardData = {
  keyword: " Round Trip Cab Booking Mumbai",

headingDescription:
  "Omshree Cab provides trusted and professional Mumbai car rental service for travelers looking for comfortable, reliable, and hassle-free transportation across the city and nearby destinations. Whether you need a car for airport transfers, corporate travel, city sightseeing, family trips, or outstation journeys, our Mumbai car rental service offers well-maintained vehicles and experienced drivers to ensure a smooth ride. We provide flexible booking options including self-drive rental, chauffeur-driven cars, luxury car hire, and corporate packages. Our fleet includes air-conditioned sedans, SUVs, tempo travelers, and luxury cars suitable for solo travelers, families, tourists, and business groups. With punctual pickups from any location in Mumbai, 24/7 customer support, and transparent pricing, Omshree Cab is your reliable partner for all Mumbai car rental needs.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks located along the Arabian Sea in South Mumbai. Built during the British era, the grand arch monument attracts thousands of visitors for photography, sightseeing, and ferry rides to Elephanta Island. The surrounding Colaba area is lively with street markets, cafes, and historic buildings, making it a perfect starting point for exploring the city. A Mumbai car rental service allows travelers to reach the Gateway comfortably and continue their sightseeing journey without worrying about traffic or parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road stretching along the Arabian Sea, famously called the Queen’s Necklace due to the lights that sparkle at night. Visitors enjoy evening walks, sunsets, and the refreshing sea breeze. Renting a car in Mumbai makes it easy to explore Marine Drive and nearby areas like Nariman Point and Chowpatty Beach comfortably while enjoying the iconic views and cityscape."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most famous beaches and a popular spot for locals and tourists alike. Visitors come to enjoy the sandy shore, sunset views, and Mumbai street foods such as pav bhaji, bhel puri, and pani puri. The beach is lively in the evenings and during festivals. Renting a car provides convenient access to Juhu Beach and nearby attractions, ensuring a relaxed and comfortable trip."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a renowned religious site in Mumbai dedicated to Lord Ganesha. Devotees from across India visit to seek blessings, especially during festivals like Ganesh Chaturthi. The temple’s peaceful atmosphere and beautiful architecture attract tourists and pilgrims alike. Using a car rental service in Mumbai ensures a comfortable visit, avoiding traffic congestion and parking issues in the busy temple vicinity."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is one of Mumbai’s most modern engineering marvels, connecting Bandra and Worli across the Arabian Sea. The cable-stayed bridge offers breathtaking views of the water and city skyline, especially at sunset or night when it’s beautifully illuminated. Renting a car in Mumbai allows travelers to enjoy this scenic route comfortably while moving between South Mumbai and western suburbs."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous mosque and shrine situated on an islet in the Arabian Sea. The white marble structure is connected to the city by a narrow walkway that appears during low tide. Visitors come to pray and experience the serene environment. Renting a car ensures easy access to this spiritual landmark without the hassle of public transport or parking."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock-cut caves on Elephanta Island, a UNESCO World Heritage Site known for intricate sculptures dedicated to Lord Shiva. Visitors travel by ferry from the Gateway of India to explore the caves and scenic surroundings. A Mumbai car rental service allows seamless transportation to the ferry point, making the journey convenient and comfortable."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a vast green forest area within Mumbai, offering trekking, cycling, and nature walks, along with historical Kanheri Caves. Visitors enjoy a day surrounded by natural beauty and wildlife. Renting a car provides hassle-free access from different parts of Mumbai, allowing tourists to explore the park efficiently."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is one of Mumbai’s busiest shopping streets, known for vibrant markets selling clothing, accessories, handicrafts, and souvenirs. The area also has cafes and restaurants offering local and international cuisine. A Mumbai car rental service allows travelers to comfortably reach this popular market and continue sightseeing in South Mumbai."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also called Pherozeshah Mehta Gardens, are beautifully landscaped gardens on Malabar Hill, offering panoramic views of Marine Drive and the Arabian Sea. Visitors enjoy peaceful walks, photography, and a relaxing environment away from city noise. Renting a car ensures convenient access and flexibility to combine this scenic location with other nearby attractions."
  }
],



services: [
{
name: "Round Trip Cab Booking Mumbai",
description: "Round trip cab booking in Mumbai provides convenient transportation for passengers planning return journeys between cities or destinations. Our fleet includes AC sedans, SUVs, and premium vehicles suitable for long-distance highway travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for family trips, business travel, and tourism visits. Spacious interiors ensure comfortable travel during long journeys. Flexible return schedules allow passengers to plan trips without worry. Reliable cab services ensure smooth round trip travel experiences."
},
{
name: "Round Trip Taxi Booking Mumbai",
description: "Round trip taxi booking in Mumbai offers reliable transportation for travelers planning a complete return journey. Comfortable AC vehicles ensure smooth travel across city roads and highways. Professional drivers ensure punctual pickup and safe driving during the entire trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for tourism trips, family travel, and corporate visits. Spacious seating ensures comfortable journeys for passengers. Flexible return timing allows convenient travel planning. Trusted taxi services ensure safe and stress-free round trip transportation."
},
{
name: "Round Trip Cab Service Mumbai",
description: "Round trip cab service in Mumbai provides dependable transportation for passengers needing a return journey after reaching their destination. Our fleet includes comfortable AC sedans and SUVs suitable for highway travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including homes, hotels, offices, and airport terminals. Ideal for outstation travel, tourism trips, and family visits. Spacious interiors ensure relaxed travel during long journeys. Flexible booking options allow passengers to plan return schedules easily. Reliable cab services ensure smooth round trip transportation."
},
{
name: "Round Trip Taxi Service Mumbai",
description: "Round trip taxi service in Mumbai offers convenient travel solutions for passengers planning both onward and return journeys. Comfortable AC taxis ensure smooth travel through city roads and highways. Professional drivers ensure punctual pickup and safe driving throughout the trip. Pickup services are available across Mumbai including homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, business trips, and family visits. Spacious seating ensures comfortable journeys during travel. Flexible scheduling allows convenient return planning. Reliable taxi services ensure stress-free round trip travel."
},
{
name: "Mumbai Round Trip Cab",
description: "Mumbai round trip cab service offers comfortable transportation for travelers needing both pickup and return travel. Our fleet includes AC sedans and SUVs suitable for city and highway journeys. Professional drivers ensure safe driving and punctual service during the entire trip. Pickup services are available across Mumbai including homes, hotels, offices, and airport terminals. Ideal for tourism trips, family visits, and corporate travel. Spacious interiors ensure comfortable journeys for passengers. Flexible travel plans allow easy return scheduling. Reliable cab services ensure smooth round trip transportation."
},
{
name: "Mumbai Round Trip Taxi",
description: "Mumbai round trip taxi service provides reliable transportation for passengers planning return journeys between cities or locations. Comfortable AC taxis ensure smooth travel throughout the trip. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for business travel, tourism visits, and family trips. Spacious seating ensures comfortable journeys during travel. Flexible return schedules allow convenient trip planning. Trusted taxi services ensure dependable round trip transportation."
},
{
name: "Round Trip Outstation Cab Mumbai",
description: "Round trip outstation cab in Mumbai provides reliable long-distance transportation for travelers visiting destinations outside the city. Our fleet includes AC sedans, SUVs, and premium vehicles suitable for highway travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including homes, hotels, offices, and airport terminals. Ideal for weekend trips, family vacations, and pilgrimage tours. Spacious interiors ensure comfortable journeys during long-distance travel. Flexible return schedules allow passengers to plan their trip conveniently. Reliable cab services ensure smooth outstation round trip travel."
},
{
name: "Round Trip Airport Taxi Mumbai",
description: "Round trip airport taxi in Mumbai offers reliable transportation for passengers traveling to and from Mumbai Airport. Comfortable AC vehicles ensure smooth travel between airport terminals and city destinations. Professional drivers monitor flight timings to provide punctual pickup and drop services. Pickup services are available from Terminal 1 and Terminal 2 of Mumbai Airport. Ideal for business travelers, tourists, and family travel. Spacious seating ensures comfortable airport journeys. Flexible booking options allow easy return scheduling. Reliable taxi services ensure stress-free airport round trip travel."
},
{
name: "Round Trip Cab Booking Online Mumbai",
description: "Round trip cab booking online in Mumbai allows passengers to reserve return travel easily using digital booking platforms. Instant booking confirmation ensures convenient ride scheduling for both onward and return journeys. Comfortable AC sedans and SUVs provide smooth highway travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including homes, hotels, offices, and airport terminals. Ideal for tourism trips, business travel, and family visits. Spacious interiors ensure comfortable journeys during travel. Reliable online cab booking ensures hassle-free round trip transportation."
}
],

tableData: [
["Round Trip Cab Booking Mumbai","Round Trip Taxi Booking Mumbai"],
["Round Trip Cab Service Mumbai","Round Trip Taxi Service Mumbai"],
["Mumbai Round Trip Cab","Mumbai Round Trip Taxi"],
["Round Trip Outstation Cab Mumbai","Round Trip Airport Taxi Mumbai"],
["Round Trip Cab Booking Online Mumbai","Round Trip Taxi Booking Online Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance and round trip travel from Mumbai to various destinations. They are familiar with highways, ghat roads, and traffic patterns, ensuring a safe and comfortable journey for passengers."
  },
  {
    WhyChooseheading: "Transparent Round Trip Pricing",
    WhyChoosedescription: "Omshree Cabs offers clear and transparent pricing for round trip cab bookings from Mumbai. Customers are informed about per-kilometer rates, toll charges, and package details before the journey begins."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our round trip cab booking service is available 24/7 in Mumbai. Whether you plan an early morning departure or a late-night return, Omshree Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained, fully air-conditioned vehicles that are regularly cleaned and sanitized to provide maximum comfort during long-distance travel."
  },
  {
    WhyChooseheading: "Flexible Round Trip Packages",
    WhyChoosedescription: "We offer flexible round trip travel plans including same-day return, multi-day trips, and customized tour packages according to your travel schedule."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides multiple vehicle choices including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for families, couples, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and airports across Mumbai for a smooth and hassle-free round trip journey."
  },
  {
    WhyChooseheading: "Reliable Outstation Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for round trip cab services from Mumbai. Our punctual service, experienced drivers, and comfortable vehicles ensure a pleasant travel experience."
  }
]
};

const faqData = [
  { question: "What is a round trip cab booking?", answer: "A round trip cab booking means the cab takes you from Mumbai to your destination and brings you back to Mumbai after your trip." },
  { question: "Do you provide round trip cab services from Mumbai?", answer: "Yes, Omshree Cabs provides round trip cab services from Mumbai to destinations like Pune, Lonavala, Nashik, Mahabaleshwar, and many other cities." },
  { question: "Can I book a same-day round trip cab?", answer: "Yes, we offer same-day return cab services for many nearby destinations from Mumbai." },
  { question: "Which vehicles are available for round trip travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your travel requirements." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, Omshree Cabs operates 24/7 for round trip and outstation cab bookings." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, sightseeing, or refreshment breaks." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and tourist seasons." },
  { question: "Do you provide customized travel plans?", answer: "Yes, we provide flexible and customized travel plans for round trip journeys." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Deshmukh",
    feedback:
      "We booked a round trip cab from Mumbai with Omshree Cabs and the experience was excellent. The driver was punctual and the vehicle was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Shah",
    feedback:
      "Very reliable round trip cab service from Mumbai. Smooth travel, transparent pricing, and great customer support.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Round Trip Cab Booking Mumbai",
  "description": "Omshree Cab provides reliable Round Trip Cab Booking in Mumbai for local, airport, and outstation travel. Book round trip taxis online easily at affordable fares. Trusted service for comfortable and hassle-free Mumbai cab journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3500"
  }
};








  return (
    <div>
      

<Helmet>
  <title>Round Trip Cab Booking Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers round trip cab booking in Mumbai for local, airport, and outstation travel. Affordable fares and trusted service for online booking of round trip taxis in Mumbai." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Roundtripcabbookingmumbai;